import { LOAD_USER_PROFILE } from '../actions/userProfileActions';

const initialState = {
  detail: {
    distributor: {}
  },
};

const UserProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_USER_PROFILE.success: {
      return {
        ...state,
        detail: { ...action.userData }
      };
    }

    default: {
      return state;
    }
  }
};

export default UserProfileReducer;
